// extracted by mini-css-extract-plugin
export default {"container":"TagTabs__container--wupXV","tabs":"TagTabs__tabs--8Y29U","tab":"TagTabs__tab--t0KtQ","active":"TagTabs__active--YxIfy"};